import { useTheme } from "next-themes";

export const getCurrentTheme = () => {
  const { theme } = useTheme();
  return theme;
};
